<template>
  <section class="px-4 py-12 md:py-16">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.how.title') }}</h2>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div v-for="(step, index) in STEPS" :key="step" class="flex flex-col items-center gap-2">
          <div class="w-12 h-12 rounded-full bg-primary text-black flex items-center justify-center">
            <VaIcon :name="ICONS[index]" size="24px" />
          </div>
          <h3 class="mb-0">{{ index + 1 }} — {{ t(`landing.how.${step}.title`) }}</h3>
          <p class="text-neutral-300 mt-0">{{ t(`landing.how.${step}.text`) }}</p>
        </div>
      </div>

      <p class="text-sm text-neutral-300 mt-6">{{ t('landing.how.note') }}</p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'

const { t } = useI18n()

const STEPS = ['name', 'feed', 'heard'] as const
const ICONS = ['edit', 'rss_feed', 'graphic_eq']
</script>
